

export class LookupListItem {
  id: number = null;
  name: string = null;
  constructor(obj: LookupListItem = null) { if (obj) { Object.assign(this, obj); } }
}

